<div class="content-blk view-product">
  <div class="container">
    <h5 class="page-title">
      <span class="text-info" *ngIf="CurrentStatus==1"><strong>New Product<small class="small"> *Under Review</small></strong></span>
      <span class="text-success" *ngIf="CurrentStatus==2"><strong>Approved </strong></span>
      <span class="text-danger" *ngIf="CurrentStatus==3"><strong>Rejected</strong></span>
      <span class="text-warning" *ngIf="CurrentStatus==4">
        <strong>
          ReSubmitted <small class="small">
            *Under
            Review
          </small>
        </strong>
      </span>

      <small class="small" (click)="fn_UpdateCustomProduct(productID)" *ngIf="CurrentStatus==3 && IsStoreAdmin"
             title="Edit and Resubmit Product" class="title-link-left">
        <span class="material-icons">edit</span>
        Edit & Resubmit
      </small>
      <small class="small" *ngIf="CurrentStatus==2 && IsStoreAdmin" (click)="fn_navigateInventoryPage(productID)"
             title="Manage Inventory" class="title-link-left">
        <span class="material-icons">format_list_numbered</span>
        Manage Inventory
      </small>

      <small class="small" *ngIf="IsSuperAdmin" (click)="fn_navigateSuperAdminInventoryPage(productID)"
             class="title-link-left">
        <span class="material-icons">local_shipping</span>
        Shipment Details
      </small>

      <small class="small" class="pull-right title-link" *ngIf="IsStoreAdmin">
        <a [routerLink]="['/store/productlisting']">Warehouse Products</a>
      </small>
      <small class="small" class="pull-right title-link" *ngIf="IsSuperAdmin">
        <a [routerLink]="['/superadmin/warehouse']">Warehouse Products</a>
      </small>
      <span class="clearfix"></span>
    </h5>
    <form [formGroup]="addCustomProductForm" autocomplete="off">
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row">
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title class="card-title">
                  Product Information
                </mat-card-title>
                <mat-card-content>
                  <div class="example-form">
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Product Title</mat-label>
                          <input matInput placeholder="Product Title" readonly formControlName="Title">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Product Description</mat-label>
                          <textarea matInput placeholder="Product Description" readonly formControlName="Description" rows="4"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                           <mat-label class="label">SKU (optional)</mat-label>
                          <input matInput placeholder="SKU (optional)" readonly formControlName="SKU">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 text-muted">
                        <span style="font-weight: bold; font-size: large;">Categories & Sub Categories</span>
                        <br />
                        <small class="small" *ngFor="let cat of Categories;let c=index">
                          <span class="text-muted">
                            {{cat.CategoryName}}
                          </span><br />
                          <span>
                            <span *ngFor="let subCat of cat.SubCatetgoryList;let sc=index">
                              &nbsp;
                              <i class="fa fa-level-up collapsed-result" aria-hidden="true"></i>
                              &nbsp;
                              {{subCat.SubCategoryName}}<br />
                            </span>
                          </span>
                        </small>
                      </div>
                    </div>

                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title class="card-title">
                  Dimension
                </mat-card-title>
                <mat-card-content>
                  <div class="example-form">
                    <div class="row text-muted">
                      <div class="col-sm-12">
                        <strong>Dimension</strong>
                        <br />
                        <small class="small">
                          Please enter the
                          dimensions of the product when it is folded or packaged for mailing.
                        </small>
                      </div>
                    </div>
                    <div class="row text-muted">
                      <div class="col-sm-6">
                        <mat-select  class="color-select" formControlName="UnitId" [disabled]="true">
                          <mat-option readonly *ngFor="let unit of Units" [value]="unit.UnitId">
                            {{unit.UnitText}}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-sm-6">
                        <br />
                        <mat-checkbox [disabled]="true" formControlName="IsPackaged">
                          <strong class="mdc-label">
                            Product is
                            packaged
                          </strong>
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Width ({{lenghtPlaceholder}})</mat-label>
                          <input matInput readonly placeholder="Width ({{lenghtPlaceholder}})" type="number" required
                                 formControlName="Width">
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Length ({{lenghtPlaceholder}})</mat-label>
                          <input matInput readonly placeholder="Length ({{lenghtPlaceholder}})" type="number"
                                 maxlength="5" required formControlName="Length">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Height ({{lenghtPlaceholder}})</mat-label>
                          <input matInput readonly placeholder="Height ({{lenghtPlaceholder}})" type="number"
                                 maxlength="5" required formControlName="Height">
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label class="label">Weight ({{weightPlaceholder}})</mat-label>
                          <input matInput readonly placeholder="Weight ({{weightPlaceholder}})" type="number"
                                 maxlength="5" required formControlName="Weight">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mat-crd-ui">
              <mat-card class="add-wh-product"
                        *ngIf="ImageHashCombination != undefined && ImageHashCombination.length > 0">
                <mat-card-title class="card-title">
                  Upload Product Image
                </mat-card-title>
                <mat-dialog-content class="table-wh-view">
                  <div class="table-responsive pro-tble-outer table-inventory-custom">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th width="25%">Color</th>
                          <th width="25%">Hex Code</th>
                          <th width="50%">Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let row of ImageHashCombination; let colorIndex = index">
                          <tr>
                            <td width="25%">
                              <strong>{{row.ColorName}}</strong>
                            </td>
                            <td width="25%">
                              <p class="display-wh-colors" title="{{row.ColorName}}"
                                 [ngStyle]="displayColor(row.HexCode)">
                                &nbsp;
                              </p>
                              <span>&nbsp;{{row.HexCode}}</span>
                            </td>
                            <td width="50%">
                              <span *ngFor="let size of row.Size; let j = index">
                                {{size.SizeName}}&nbsp;&nbsp;&nbsp;
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3" style="border:none;">
                              <span *ngFor='let img of row.WarehouseProductImages; let i = index;'>
                                <img height="50" [src]="fn_GetImage(img.ImageName)" class="product-wh-img" />
                              </span>

                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </mat-dialog-content>
              </mat-card>


              <mat-card class="add-wh-product text-muted" *ngIf="CanSuperAdminSee">
                <mat-card-content>
                  <div>
                    <span style="font-weight: bold; font-size: large;">
                      Update Custom Product Approval Status
                    </span>
                  </div>
                  <div>
                    <small class="small" class="text-muted">
                      Mark the custom product Approved or Rejected, add additional information for Store Admin on custom
                      product status in the comment section below.
                    </small>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-sm-12 view-status">
                      <!-- <span *ngFor="let radiobutton of radioItems">
                        <input type="radio" name="options" (click)="Status = radiobutton"><span>&nbsp;&nbsp;&nbsp;</span>{{radiobutton}}&nbsp;&nbsp;&nbsp;
                      </span> -->
                      <mat-radio-group>
                        <ul class="sz-lst-ul sz-lst-ul-flx">
                          <li *ngFor="let radiobutton of radioItems">
                            <mat-radio-button [value]="radiobutton" checked="false" (click)="Status = radiobutton">
                              {{radiobutton}}
                            </mat-radio-button>
                          </li>
                        </ul>
                      </mat-radio-group>
                    </div>
                  </div>
                  <br />
                  <div class="row" *ngIf="Status == 'Rejected'">
                    <div class="col-sm-12">
                      <mat-form-field class="example-full-width">
                        <mat-label class="label">Comments</mat-label>
                        <textarea matInput placeholder="Comments" [required]="Status == 'Rejected'" rows="5"
                                  class="comment-wh-product" [ngModelOptions]="{standalone: true}"
                                  [(ngModel)]="Comments"></textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="text-right sv-up-dt">
                    <button class="mat-btn" mat-raised-button cdkFocusInitial
                            [disabled]="(Status == 'Rejected' && !Comments) || Status == undefined"
                            (click)="fn_OnApproval(Comments,Status)">
                      Submit
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card class="add-wh-product text-muted" *ngIf="CustomLogList.length > 0">
                <mat-card-content>
                  <div>
                    <span style="font-weight: bold; font-size: large;">
                      Custom Product Approval Status Log
                    </span>
                  </div>
                  <br />
                  <div class="table-responsive table-log-custom">
                    <table class="table table-sm">
                      <thead>
                        <tr class="table-active">
                          <th>#</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th width="60%">Comment</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let log of CustomLogList;let i=index">
                          <td>{{i + 1}}</td>
                          <td>{{log.Date | date }}</td>
                          <td>
                            <strong class="text-info" *ngIf="log.Status==1"><strong>New</strong></strong>
                            <strong class="text-success" *ngIf="log.Status==2"><strong>Approved</strong></strong>
                            <strong class="text-danger" *ngIf="log.Status==3"><strong>Rejected</strong></strong>
                            <strong class="text-warning" *ngIf="log.Status==4"><strong>ReSubmitted</strong></strong>
                          </td>
                          <td>
                            <span class="comment-wh-product">{{log.Comment}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
